export const initialState = {
    loading: false,
    error: null,
    success: null
}